import useNativeShareAvailable from './useNativeShareAvailable'
export default useNativeShareAvailable
